import React, { useContext, useEffect, useState } from 'react'

import styled from 'styled-components'

import FilterStorage from '../../../../storage/FilterStorage/FilterStorage'
import { FlexColumn } from '../../../projectComponents'
import { FilterInput, FilterRange, SidebarTitle } from './filterStyles'

const Block = styled(FlexColumn)`
  width: 100%;
  align-items: stretch;
  gap: 16px;
`

interface SelectPriceComponentProps {
  title: string
}

export const FilterPricePanel: React.FC<SelectPriceComponentProps> = ({ title }) => {
  const { setDayPriceFrom, setDayPriceTo, sorting } = useContext(FilterStorage)
  const [priceFrom, setPriceFrom] = useState<number | string>(sorting.dayPriceFrom || '')
  const [priceTo, setPriceTo] = useState<number | string>(sorting.dayPriceTo || '')
  const [validError, setValidError] = useState('')

  useEffect(() => {
    if (priceTo && +priceFrom > +priceTo) {
      setValidError('Минимальная цена не может быть больше максимальной')
    } else {
      setValidError('')
    }
  }, [priceFrom, priceTo])

  return (
    <Block>
      <SidebarTitle>{title}</SidebarTitle>
      <FilterRange>
        <FilterInput
          label="От"
          inputProps={{
            'aria-label': 'Минимальная цена за сутки',
            min: 0,
            onChange: (e: React.ChangeEvent<HTMLInputElement>) => setPriceFrom(e.target.value),
            placeholder: 'От',
            type: 'number',
            value: priceFrom,
          }}
          error={validError}
          onBlur={() => setDayPriceFrom(+priceFrom)}
          size={'md'}
          fullwidth
        />
        <FilterInput
          label="До"
          inputProps={{
            'aria-label': 'Максимальная цена за сутки',
            min: 0,
            onChange: (e: React.ChangeEvent<HTMLInputElement>) => setPriceTo(e.target.value),
            placeholder: 'До',
            type: 'number',
            value: priceTo,
          }}
          onBlur={() => setDayPriceTo(+priceTo)}
          size={'md'}
          fullwidth
        />
      </FilterRange>
    </Block>
  )
}
